import strFunc from '@/lib/lyg/string';

function TodoDailycStarArea(props: any) {
  let myProps = {
    todo_dailyc_info: null,
    ...props
  };
  let todo_dailyc_info = myProps.todo_dailyc_info;
  let todo_dailyc_star_cnt = 0;
  if (todo_dailyc_info != null) {
    if (todo_dailyc_info["a_star_cnt"]) {
      todo_dailyc_star_cnt += parseInt(strFunc.uncomma(todo_dailyc_info["a_star_cnt"]));
    }
    if (todo_dailyc_info["a_teacher_star"]) {
      todo_dailyc_star_cnt += parseInt(strFunc.uncomma(todo_dailyc_info["a_teacher_star"]));
    }
  }
  let default_style: any = {
    position: "absolute",
    // top: 0,
    // left: 0,
    width: 50,
    height: 50,
    zIndex: 2,
  };
  let start_img_src = process.env.REACT_APP_API_URL + "/img/comp/plan/star_yellow50.png";
  let star_data_arr: any = [
    {
      src: start_img_src,
      style: {
        top: 85,
        left: 10,
      },
    },
    {
      src: start_img_src,
      style: {
        top: 65,
        left: 52,
      },
    },
    {
      src: start_img_src,
      style: {
        top: 50,
        left: 92,
      },
    },
  ];

  const get_start_tags=()=>{
    let star_tags=star_data_arr.map((item:any,idx:number)=>{
      if(idx<todo_dailyc_star_cnt){}else{
        return "";
      }
      
      return (
        <img key={idx} src={item.src} style={{...default_style,...item.style}} />
      );
    });
    return star_tags;
  };

  return (
    <>
      {get_start_tags()}
    </>
  );
};
export default TodoDailycStarArea;